import { BaseInsightsQueryParams, InsightsChartType, QueryParamDataType } from '../constants';
import insightsDateRangeValidator from './paramValidators/insightsDateRangeValidator';

const InsightsPageQueryParams = {
  [BaseInsightsQueryParams.START_DATE]: {
    required: true,
    customValidator: insightsDateRangeValidator(BaseInsightsQueryParams.START_DATE),
    type: QueryParamDataType.DATE,
  },
  [BaseInsightsQueryParams.END_DATE]: {
    required: true,
    customValidator: insightsDateRangeValidator(BaseInsightsQueryParams.END_DATE),
    type: QueryParamDataType.DATE,
  },
  [BaseInsightsQueryParams.CHART_TYPE]: {
    required: true,
    type: QueryParamDataType.CUSTOM,
    default: InsightsChartType.BAR,
    acceptedValues: InsightsChartType,
  },
};

export default InsightsPageQueryParams;
